import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Divider } from "antd";
import { isNil, isEmpty } from 'lodash';
import { ReactComponent as EdgelIcon } from "../../../../../assets/icons/edge.svg";
import reject_icon from "../../../../../assets/icons/reject_icon.png";
import return_icon from "../../../../../assets/icons/return_icon.png";
import cross_icon from "../../../../../assets/icons/cross_icon.png";
import check_icon from "../../../../../assets/icons/check_icon.png";

const Graph = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  console.log("apptrackDetails?.activeTaskName:",apptrackDetails?.activeTaskName);

  return (
    <>
      <Row gutter={32} className="diagram-container">
        <Col span={24} style={{display: "flex", justifyContent: "center", marginBottom: "2rem", position: "relative"}}>
          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.application_rejection"
                ? "active-reject-node "
                : "") + "reject-node"
            }
          >
            <img style={{marginLeft:"5px"}} src={reject_icon}></img>
            <span>Απόρριψη Αίτησης</span>
          </div>
          
          {/* Left dashed line (gray) */}
          <div style={{
            position: "absolute",
            top: "95px",
            left: "calc(53% - 100px)",
            width: "1px",
            height: "60px",
            borderLeft: "2px dashed #999",
            zIndex: 1000
          }}></div>
          
          {/* Left triangle pointing up */}
          <div style={{
            position: "absolute",
            top: "90px",
            left: "calc(53.1% - 105px)",
            width: "0",
            height: "0",
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderBottom: "5px solid #999",
            zIndex: 1000
          }}></div>
          
          {/* Right dashed line (green) */}
          <div style={{
            position: "absolute", 
            top: "95px",
            left: "calc(46.5% + 100px)",
            width: "1px",
            height: "60px",
            borderLeft: "2px dashed #28a745",
            zIndex: 1000
          }}></div>
          
          {/* Right triangle pointing down */}
          <div style={{
            position: "absolute",
            top: "157px",
            left: "calc(46.6% + 95px)",
            width: "0",
            height: "0",
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderTop: "5px solid #28a745",
            zIndex: 1000
          }}></div>
        </Col>

        <Col span={24} className="main-flow-nodes" style={{marginTop: "3rem"}}>
          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.submit_application"
                ? "active-completion-node "
                : "") + "state-node first"
            }
          >
            <span>Υποβολή Αίτησης</span>
          </div>

          <EdgelIcon className="edge-svg" />

          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.audit_application"
                ? "active-completion-node "
                : "") + "state-node second"
            }
          >
            <span>Αξιολόγηση Αίτησης</span>
          </div>

          <EdgelIcon className="edge-svg" />

          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.implementation_monitoring"
                ? "active-completion-node "
                : "") + "state-node third"
            }
            style={{position: "relative"}}
          >
            <span>Προσωρινή Ένταξη</span>
            
            {/* Third dashed line pointing down to Απένταξη Αίτησης */}
            <div style={{
              position: "absolute",
              top: "58px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "1px",
              height: "60px",
              borderLeft: "2px dashed #999",
              zIndex: 1000
            }}></div>
            
            {/* Third triangle pointing down */}
            <div style={{
              position: "absolute",
              top: "120px",
              left: "52.5%",
              transform: "translateX(-50%)",
              marginLeft: "-5px",
              width: "0",
              height: "0",
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderTop: "5px solid #999",
              zIndex: 1000
            }}></div>
          </div>

          <EdgelIcon className="edge-svg" />

          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.implementation_monitoring_doc_submission"
                ? "active-completion-node "
                : "") + "state-node fourth"
            }
          >
            <span>Έναρξη Προγράμματος</span>
          </div>

          {/* Commented out rejection/return nodes for now */}
          {/*
          <div className='reject-nodes'>
            <div className="return-dashed-edge-2"></div>
            <div className="return-triangle-2"></div>
            <div
              className={
                (apptrackDetails?.activeTaskName == "task.name.application_cancellation"
                  ? "active-reject-node "
                  : "") + "reject-node"
              }
            >
              <img style={{marginLeft:"5px"}} src={reject_icon}></img>
              <span>Ακύρωση Αίτησης</span>
            </div>
          </div>

          <div className='return-nodes'>
            <div className="return-dashed-edge"></div>
            <div className="return-triangle"></div>
            <div
              className={
                (apptrackDetails?.activeTaskName == "task.name.application_return_to_beneficiary"
                  ? "active-return-node "
                  : "") + "return-node"
              }
            >
              <img style={{marginLeft:"5px"}} src={return_icon}></img>
              <span>Επιστροφή στον Ωφελούμενο</span>
            </div>
          </div>

          <div className='reject-nodes-2'>
            <div
              className={
                (apptrackDetails?.activeTaskName == "task.name.application_withdrawal"
                  ? "active-reject-node "
                  : "") + "reject-node-2"
              }
            >
              <img style={{marginLeft:"5px"}} src={reject_icon}></img>
              <span>Απένταξη Αίτησης</span>
            </div>
            <div className="return-dashed-edge-3"></div>
            <div className="return-triangle-3"></div>
          </div>
          */}
        </Col>

        <Col span={24} style={{display: "flex", justifyContent: "center", paddingLeft: "215px"}}>
          <div
            className={
              (apptrackDetails?.activeTaskName == "task.name.application_withdrawal"
                ? "active-reject-node "
                : "") + "reject-node-2"
            }
          >
            <img style={{marginLeft:"5px"}} src={reject_icon}></img>
            <span>Απένταξη Αίτησης</span>
          </div>
        </Col>
      </Row>

      <Row gutter={32}>
        <Col span={24} style={{ height: 56 }}></Col>
      </Row>
    </>
  );
};

export default Graph;